<template>
    <!--弹窗-->
    <el-dialog width="700px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="140px" :rules="rules">
            <el-form-item label="充值金额：" prop="amount">
                <el-input v-model="formData.amount" style="width: 200px;margin-right:20px;" placeholder="请输入充值金额" disabled></el-input>
            </el-form-item>
            <el-form-item label="充值货币：" > 
                <el-select v-model="currency" placeholder="选择充值货币" disabled>
                    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上传凭证：">
                <div v-show="formData.image" style="display: inline-block;position: relative;margin-right: 30px;">
                    <img class="img" :src="formData.image" alt="" >
                </div>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/user/payorders";
export default {
    data() {
        return {
            loading: false,
            currency: "CNY",
            roles: [
                {
                    id: "CNY",
                    name: "人民币"
                },
                {
                    id: "USD",
                    name: "美金"
                }
            ],
            rules: {
                amount: [
                    {
                        required: true,
                        message: "请输入充值金额",
                        trigger: "blur"
                    }
                ],
                currency: [
                    {
                        required: true,
                        message: "选择充值货币",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        wangc() {
            let obj = {};
            obj.admin_id = this.formData.admin_id;
            obj.amount = this.formData.amount;
            obj.charge_request_id = this.formData.id;
            api.charge_index(obj)
                .then(res => {
                    if (res.code === 0) {
                        // 提交成功, 关闭窗口, 刷新列表
                        this.$message({
                            message: "充值成功",
                            type: "success"
                        });
                        this.handleClose();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面查看订单是否完成！"
                    });
                });
        },
        // 保存信息
        submitForm(formData) {
            let that = this;
            this.$refs[formData].validate(valid => {
                if (valid) {
                    if (!this.formData.image) {
                        this.$message({
                            type: "error",
                            message: "请上传支付凭证"
                        });
                        return;
                    }
                    this.loading = true;
                    api.process_request({ id: this.formData.id })
                        .then(res => {
                            if (res.code === 0) {
                                that.wangc();
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.$message({
                                type: "error",
                                message:
                                    "网络出现问题，请刷新页面查看订单是否完成！"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose() {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback");
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.img {
    width: 400px;
    border: 1px rgb(206, 202, 202) solid;
}
.img-cha {
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    top: 0;
    right: 0;
    font-size: 20px;
}
</style>
